export function useScale(): number {
  return 1.0;
}
